"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGlobalStyles = exports.DefaultGlobalCss = exports.GlobalCss = void 0;
var core_1 = require("@emotion/core");
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../hooks");
exports.GlobalCss = core_1.Global;
exports.DefaultGlobalCss = function () {
    var theme = hooks_1.useTheme();
    return react_1.default.createElement(exports.GlobalCss, { styles: exports.createGlobalStyles(theme) });
};
exports.createGlobalStyles = function (theme) { return ({
    html: {
        fontSize: theme.typography.sizes.html,
        boxSizing: 'border-box',
    },
    '*, *:before, *:after': {
        boxSizing: 'inherit',
    },
    body: {
        margin: 0,
        color: theme.pallete.text.main,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.sizes.text,
        overflowY: 'scroll',
    },
    hr: {
        backgroundColor: theme.pallete.divider,
        border: 'none',
        height: 1,
        margin: '1rem 0',
    },
    h1: { margin: 0, fontSize: '1.5rem' },
    h2: { margin: 0, fontSize: '1.25rem' },
    h3: { margin: 0, fontSize: '1rem' },
    h4: { margin: 0, fontSize: '0.875rem' },
    h5: { margin: 0, fontSize: '0.8125rem' },
    h6: { margin: 0, fontSize: '0.75rem' },
    p: {
        margin: '0',
        lineHeight: 1.5,
    },
}); };
//# sourceMappingURL=GlobalCss.js.map